const siteMaintenance = {
  key: "site-maintenance",
  title: "Site Maintenance",
  angle: -140,
  summary: "Coordinate inspections, actions, and closeout in one workspace.",
  releaseDate: "Late 2027",
  launch: "/",
  planStages: [
    {
      name: "Scoping documents",
      detail: [
        {
          text: "Concept feature",
          checked: true,
        },
        {
          text: "Business Systems Requirements Document (BSRD)",
          checked: false,
        },
        {
          text: "Functional Design Document (FDD)",
          checked: false,
        },
      ],
      completionDate: "Nov 26",
    },
    {
      name: "Development",
      detail: [
        {
          text: "Admin feature development & testing",
          checked: false,
        },
        {
          text: "Main feature development",
          checked: false,
        },
        {
          text: "Initial data entry (this is ongoing and will continue after initial release)",
          checked: false,
        },
        {
          text: "Development phase testing",
          checked: false,
        },
      ],
      completionDate: "Sep 27",
    },
    {
      name: "Testing & QA",
      detail: [
        {
          text: "Workflow documents production",
          checked: false,
        },
        {
          text: "Main feature testing",
          checked: false,
        },
        {
          text: "Training & support documentation production",
          checked: false,
        },
        {
          text: "Training and deployment",
          checked: false,
        },
      ],
      completionDate: "Dec 27",
    },
  ],
  points: [
    "Track live maintenance status",
    "Manage maintenance by objects and assets (e.g. pumps, valves, instruments, etc.) accessed via the 3D-model",
    "Capture and resolve issues faster",
  ],
};

export default siteMaintenance;
